import { LOCATIONS_SECTION } from '@/features/settingsPage/consts/sections';
import { getSectionUrl } from '@/features/settingsPage/structs/section';

export const ROUTE_PATH = getSectionUrl(LOCATIONS_SECTION);
